module.exports = "/images/hamburger-hover.svg";